<template>
  <div class="TableWithTotals">
    <v-card-text v-if="searchActive && dataVals !== null">
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-text>

    <v-data-table
      dense
      :headers="headers"
      :items="dataVals"
      :search="search"
      :custom-filter="customFilter"
      no-results-text="No se encontro el término buscado"
      no-data-text="No hay datos disponibles"
      multi-sort
      disable-initial-sort
      class="elevation-1"
      loading="Cargando... Por favor espere."
      rows-per-page-text="Filas por página:"
    >
      <template slot="items" slot-scope="props">
        <td
          v-for="col in columns"
          :key="col.id"
          :align="align(props.item[col])"
        >
          <template v-if="props.item[col].url">
            <v-icon
              large
              @click="openLink(props.item[col].url)"
              color="green darken-2"
            >
            cloud_download
            </v-icon>
          </template>
          <template v-else-if="props.item[col]==='Infinity'">

          </template>
          <template v-else>
            {{ props.item[col] }}
          </template>
        </td>
      </template>

      <template v-if="dataVals.length !== 0" v-slot:footer>
        <td
          v-for="total in totals"
          :key="total.id"
          :align="align(total)"
        >
          <b>{{ total }}</b>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'TableWithTotals',

  /**
   * Elementos que recibe el componente para renderizar
   */
  props: {
    /** Cabecera de la tabla */
    headers: {
      type: Array,
      required: true
    },
    /** Contenido de la tabla */
    dataVals: {
      type: Array,
      required: true
    },
    /** Habilita o desahbilita la busqueda */
    searchActive: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data: function () {
    return {
      search: '',
      rowsPerPageItems: [5, 10, 20, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }]
    }
  },

  computed: {
    /**
     * Devuelve los valores de los identificadores de las columnas de la tabla
     * @return {[Array]} valores de los id de columnas
     */
    'columns': function columns () {
      if (this.headers.length === 0) {
        return []
      }

      var colVals = []
      this.headers.forEach(function (element) {
        colVals.push(element.value)
      })
      return colVals
    },

    /**
     * Devuelve los valores de las sumatorias de las diferentes columnas,
     * en caso de encontrar un NaN lo evalua como 0
     * Si la columna tiene un valos str, usa este valor como total
     * Si la columna tiene un valor enu, devuelve el total de filas
     * Si la columna tiene un valor prm, devuelve el promedio de la sumatoria.
     * @return {Array} sumatorias de las columnas
     */
    'totals': function totals () {
      var sums = []

      for (var i = 0; i < this.columns.length; i++) {
        if (this.headers[i].str) {
          sums.push(this.headers[i].str)
        } else if (this.headers[i].enu) {
          sums.push(this.dataVals.length)
        } else if (this.headers[i].prm) {
          let cmp = this.columns[i]
          let tot = this.dataVals.length
          let perc = this.dataVals.reduce(function (accumulator, val) {
            return accumulator + parseFloat(val[cmp]) / tot
          }, 0)
          sums.push(Number.parseFloat(perc).toFixed(1))
        } else {
          let cmp = this.columns[i]
          sums.push(this.dataVals.reduce(function (accumulator, val) {
            return accumulator + (val[cmp] ? val[cmp] : 0)
          }, 0))
        }
      }

      return sums
    }
  },

  methods: {
    /**
     * Determina la alineación de la celda, si es string se alinea a la izquierda
     * para los demas casos se alinea a la derecha
     * @param  {string} val El valor a evaluar
     * @return {string}     La alineación a usar
     */
    align (val) {
      let algn = 'right'
      let type = typeof val

      switch (type) {
        case 'string':
          if (val[val.length - 1] === '%' || val[val.length - 2] === '.') {
            algn = 'right'
          } else {
            algn = 'left'
          }
          break
        case 'number':
          algn = 'right'
          break
        default:
          algn = 'left'
      }

      return algn
    },
    /**
     * Su funcion es abrir una pagina con direccion
     * al url que se le pasa como parametro
     * @param  {string} url La url a abrir
     *
     */
    openLink (url) {
      window.open(url)
    }
  }
}
</script>
